import React from 'react';
import Type from 'prop-types';
import InputMask from 'react-input-mask';
import { TextField } from '@mui/material';
import { fieldToTextField } from 'formik-mui';

const PhoneField = (props) => {
  const { mask, maskPlaceholder, ...other } = props;
  const {
    field: { value },
  } = other;
  const {
    onChange,
    onBlur,
    value: valueProp,
    disabled,
    ...otherTextFieldProps
  } = fieldToTextField(other);

  const newValue =
    value?.length > 0 && value[0] === '8' ? value?.substr(1) : value;

  return (
    <InputMask
      value={newValue}
      mask={mask}
      maskPlaceholder={maskPlaceholder}
      onChange={onChange}
      onBlur={onBlur}
      disabled={disabled}
    >
      <TextField {...otherTextFieldProps} />
    </InputMask>
  );
};

PhoneField.propTypes = {
  label: Type.string.isRequired,
  type: Type.string,
  field: Type.shape({
    name: Type.string.isRequired,
    value: Type.string.isRequired,
    onChange: Type.func.isRequired,
    onBlur: Type.func.isRequired,
  }).isRequired,
  mask: Type.oneOfType([
    Type.string,
    Type.arrayOf(Type.oneOfType([Type.string, Type.instanceOf(RegExp)])),
  ]).isRequired,
  maskPlaceholder: Type.string,
  disabled: Type.bool,
};

PhoneField.defaultProps = {
  type: 'text',
  maskPlaceholder: null,
  disabled: false,
};

export default PhoneField;
